module.exports = __webpack_public_path__ + "static/email.8fa8302d.png";